import axios from 'axios';

const list = (data) => axios.get('/dev/iot/list', data);//联网设备列表
const save = (data) => axios.post('/dev/iot/save', data);//联网设备保存
const update = (data) => axios.put('/dev/iot/update', data);//联网设备保存
const del = (data) => axios.delete('/dev/iot/delete', data);//联网设备
const info = (data) => axios.get('/dev/iot/info/'+data.params.id, data);//详情


//联网设备表计管理
const relationDelete = (data) => axios.delete('/safe/iot/relation/delete', data);
//联网设备运维记录
const opsDelete = (data) => axios.delete('/safe/ops/delete', data);






export default {
  list,
  save,
  del,
  info,
  update,
  relationDelete,
  opsDelete,


}


